import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Sprachschalter nur in Nicht-Produktionsumgebungen aktivieren
const isLanguageSwitcherEnabled = process.env.REACT_APP_ENV !== 'production';

// TypeScript-Interface für die i18n-Konfiguration
interface I18nConfig {
  supportedLngs: string[];
  fallbackLng: string;
  lng?: string;
  detection?: {
    order: string[];
    caches: string[];
  };
  backend: {
    loadPath: string;
  };
  react: {
    useSuspense: boolean;
  };
}

// Basis-Konfiguration
const config: I18nConfig = {
  supportedLngs: ["en", "de"],
  fallbackLng: "de",
  backend: {
    loadPath: "/locales/{{lng}}/translation.json",
  },
  react: { useSuspense: true },
};

// Initialisierung mit HttpApi
i18n.use(HttpApi);

// Language Detector nur verwenden, wenn der Sprachschalter aktiviert ist
if (isLanguageSwitcherEnabled) {
  i18n.use(LanguageDetector);
  // Detection-Konfiguration hinzufügen
  config.detection = {
    order: ["path", "cookie", "htmlTag", "localStorage", "subdomain"],
    caches: ["cookie"],
  };
} else {
  // Feste Sprache auf Deutsch setzen, wenn Sprachschalter deaktiviert ist
  config.lng = "de";
}

// React-i18next Initialisierung
i18n.use(initReactI18next).init(config);

export default i18n; 